import React, { useEffect, useRef, useState } from "react";
import CanvasBox from "../components/3d-scene/CanvasBox";
import { connect, useSelector } from "react-redux";
import { setColor } from "../helper/threeHeper";
import { DoubleSide, Plane, Vector3 } from "three";
import ReactUI from "./reactui";
import { useHistory } from "react-router-dom";
import { useMemo } from "react";
import {
  PAGES
} from "../constants/options";

const RefCanvasBox = React.forwardRef((props, ref) => (
  <CanvasBox ref={ref} {...props} />
));
RefCanvasBox.displayName = "RefCanvasBox";

// let activeObjectIds = [];


const Index = (props) => {
  const { roles, authMiddleware } = props;
  const [setIsIntroduction] = useState(false);
  const controls = useRef();
  const refScene = useRef();
  const history = useHistory();
  const activeObjectIds = useRef([])

  const TOPMOST_VERTEX_Y = 140;
  const clipPlanes = useMemo(() => [
    new Plane(new Vector3(0, -1, 0), TOPMOST_VERTEX_Y),
    new Plane(new Vector3(0, +1, 0), TOPMOST_VERTEX_Y),
  ]);

  const page = useSelector((state) => state.home.page);
  const unitIds = useSelector((state) => state.unitExplore.units).map((item) => item["3d_asset"]?.id);

  useEffect(() => {
    authMiddleware(roles, history);
  }, []);

  let activeColorModel = {};

  async function setActiveObjectIds(ids) {
    let prevIds = [];
    for (const index in activeObjectIds.current) {
      if (!ids.includes(activeObjectIds.current[index])) {
        prevIds.push(activeObjectIds.current[index]);
      }
    }
    activeObjectIds.current = ids;
    await handleResetObjectColor(prevIds);
    handleSetActiveObjectColor();
  }

  function resetActiveColorModel(model) {
    activeColorModel = model;
  }

  const handleResetObjectColor = async (prevIds = []) => {
    refScene.current &&
      (prevIds || []).forEach((item) => {
        let objectSelector = refScene.current.getObjectByName(item);
        if (objectSelector) {
          setColor(
            objectSelector.userData.color,
            objectSelector.userData.active_alpha,
            objectSelector,
            objectSelector.userData.emissive,
          );
          objectSelector.userData.isActive = false;
        }
      });
  };

  const handleSetActiveObjectColor = () => {
    refScene.current &&
      (activeObjectIds.current || []).forEach((item) => {
        let objectSelector = refScene.current.getObjectByName(item);
        if (objectSelector) {
          let activeColor =
            activeColorModel["" + item]?.colorCode ??
            objectSelector.userData.active_color;
          setColor(
            activeColor,
            objectSelector.userData.active_alpha,
            objectSelector,
            objectSelector.userData.active_emissive,
          );
          objectSelector.userData.isActive = true;
        }
      });
  };

  return (
    <>
      {
        !props.isLoading &&
        <CanvasBox
          isPresentation={false}
          ref={refScene}
          controls={controls}
          objects={props.assets}
          hotspots={props.hotspots}
          activeObjectIds={[]}
          setActiveObjectIds={setActiveObjectIds}
          _3dSetting={props.settings}
          fbxs={props.fbxs}
          pagesSettings={props.pagesSettings}
          isIntroduction={true}
          targetPosition={controls.current?.getCurrentTarget() ?? new Vector3()}
        />
      }
      <ReactUI
        isPresentation={false}
        setIsIntroduction={setIsIntroduction}
        controls={controls}
        refScene={refScene}
        setActiveObjectIds={setActiveObjectIds}
        resetActiveColorModel={resetActiveColorModel}
        activeObjectIds={activeObjectIds.current}
      />
      {/* <LanguageModal isPresentation={false} /> */}
    </>
  );
};

const mapStateToProps = (state) => {
  const { scene } = state;
  return {
    settings: scene.settings,
    assets: scene.assets,
    hotspots: scene.hotspots,
    fbxs: scene.fbxs,
    isLoading: scene.isLoading,
    pagesSettings: scene.pagesSettings,
  };
};
export default connect(mapStateToProps)(Index);
